import { render, staticRenderFns } from "./ADATA-members-table.vue?vue&type=template&id=1338e16e&scoped=true&"
import script from "./ADATA-members-table.vue?vue&type=script&lang=js&"
export * from "./ADATA-members-table.vue?vue&type=script&lang=js&"
import style0 from "./ADATA-members-table.vue?vue&type=style&index=0&id=1338e16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1338e16e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VIcon,VSimpleTable})
